import React, { useState } from "react";
import { CARD_STYLE } from "../../../../constants/styles";
import { GREY_GRADIENT_PANEL_BACKGROUND } from "../../../../constants/styles";
import {ADMIN_PANEL_BACKGROUND_COLOR } from "../../../../constants/styles";

export default function QuestionnaireUserAllocationModal({ open, onClose, onSave }) {

  const [search, setSearch] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);

  // Dummy user list for now
  const users = [
    { id: 1, name: "Alice Johnson", department: "Finance" },
    { id: 2, name: "Mark Spencer", department: "Operations" },
    { id: 3, name: "Rachel Green", department: "HR" },
    { id: 4, name: "Tom Willis", department: "IT" },
    { id: 5, name: "Priya Patel", department: "Facilities" }
  ];

  if (!open) return null;

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.35)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999
  };

  const modalStyle = {
    ...CARD_STYLE,
    width: "700px",
    padding: "0",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
	background:ADMIN_PANEL_BACKGROUND_COLOR
  };

  const headerStyle = {
    padding: "14px 20px",
    borderBottom: "1px solid #ddd",
    fontWeight: "600",
    fontSize: "14px",
    background:  GREY_GRADIENT_PANEL_BACKGROUND
  };

  const bodyStyle = {
    display: "flex",
    padding: "20px",
    gap: "20px"
  };

  const panelStyle = {
    flex: 1,
    border: "1px solid #ddd",
    borderRadius: "6px",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden"
  };

  const panelHeader = {
    padding: "8px 12px",
    fontSize: "12px",
    fontWeight: "600",
    borderBottom: "1px solid #ddd",
    background:  GREY_GRADIENT_PANEL_BACKGROUND
  };

  const listStyle = {
    flex: 1,
    overflowY: "auto"
  };

  const rowStyle = {
    padding: "6px 10px",
    fontSize: "12px",
    display: "flex",
    justifyContent: "space-between",
    cursor: "pointer",
    borderBottom: "1px solid #eee"
  };

  const footerStyle = {
    padding: "12px 20px",
    borderTop: "1px solid #ddd",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    background: GREY_GRADIENT_PANEL_BACKGROUND
  };

  const buttonStyle = {
    padding: "6px 14px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    background: "linear-gradient(180deg, #f4f6f8, #e6e8eb)",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "600"
  };

  const filteredUsers = users.filter(u =>
    u.name.toLowerCase().includes(search.toLowerCase()) ||
    u.department.toLowerCase().includes(search.toLowerCase())
  );

  const toggleUser = (user) => {
    if (selectedUsers.find(u => u.id === user.id)) {
      setSelectedUsers(selectedUsers.filter(u => u.id !== user.id));
    } else {
      setSelectedUsers([...selectedUsers, user]);
    }
  };

  const handleSave = () => {
    onSave(selectedUsers);
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>

        {/* HEADER */}
        <div style={headerStyle}>
          Allocate Questionnaire to Users
        </div>

        {/* BODY */}
        <div style={bodyStyle}>

          {/* AVAILABLE USERS */}
          <div style={panelStyle}>
            <div style={panelHeader}>Available Users</div>
            <div style={{ padding: "8px" }}>
              <input
                placeholder="Search users..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  width: "calc(100% - 20px)",
                  padding: "6px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  fontSize: "12px",
				  background:ADMIN_PANEL_BACKGROUND_COLOR
                }}
              />
            </div>
            <div style={listStyle}>
              {filteredUsers.map(user => (
                <div
                  key={user.id}
                  style={rowStyle}
                  onClick={() => toggleUser(user)}
                >
                  <div>{user.name}</div>
                  <div style={{ color: "#666" }}>{user.department}</div>
                </div>
              ))}
            </div>
          </div>

          {/* SELECTED USERS */}
          <div style={panelStyle}>
            <div style={panelHeader}>Selected Users</div>
            <div style={listStyle}>
              {selectedUsers.map(user => (
                <div
                  key={user.id}
                  style={rowStyle}
                  onClick={() => toggleUser(user)}
                >
                  <div>{user.name}</div>
                  <div style={{ color: "#666" }}>{user.department}</div>
                </div>
              ))}
              {selectedUsers.length === 0 && (
                <div style={{ padding: "10px", fontSize: "12px", color: "#888" }}>
                  No users selected
                </div>
              )}
            </div>
          </div>

        </div>

        {/* FOOTER */}
        <div style={footerStyle}>
          <button style={buttonStyle} onClick={onClose}>Cancel</button>
          <button style={buttonStyle} onClick={handleSave}>Save Allocation</button>
        </div>

      </div>
    </div>
  );
}
